import { gql } from '@apollo/client';

// 用 alias 让响应根字段保持 queryDailyHubOperationDetailList，
// 复用 QueryDailyHubOperationDetailListResponse 类型，避免 drawer 改字段路径
export const QUERY_SORTING_HOURLY_DETAIL_LIST = gql`
    query QuerySortingHourlyDetailList($input: SortingHourlyDetailPageRequestInput!) {
        queryDailyHubOperationDetailList: querySortingHourlyDetailList(input: $input) {
            content {
                id
                orderId
                trackingNumber
                hubId
                hubName
                customerName
                businessType
                isNextDayHandover
                clientName
                arrivalTime
                departureTime
                deliveryTime
                wrongSortType
                shouldDeliveryAddress
                actualDeliveryAddress
                currentNoUpdateHours
                lastTrackingUpdateTime
                maxNoUpdateHours
                noUpdateWrongSortEverStatus
                statDate
                overallStatus
                lastSortOperationAccountName
                lastSortOperationAccountRole
                wrongLineMissortScanDriverName
                wrongLineMissortScanDspName
                lastMileServiceProviderName
                sortErrorType
                missortedLogicType
                lastSortingHubScanAccountName
                lastSortingHubScanTime
                lastSortingHubScanTrackingEvent
                lastSortingHubScanBagNumber
                isLastBaggingCorrect
                lastBaggingBagNumber
                lastSortOperationTime
                extSortingRule
            }
            page
            size
            totalElements
            totalPages
            hasNext
            hasPrevious
        }
    }
`;
